<template>
<div class="chapter">
<div class="inner_page">
<div class="wrap">
<p class="image"><img alt="image" class="vertical" src="images/f0004-01.jpg"/></p>
</div>
<div id="copyright">
<p><a id="page_4"></a><a id="copy"></a>Text copyright © 2017 by Heidi Gibson.<br/>Photographs copyright © 2017 by Antonis Achilleos.</p>
<p>All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p>ISBN 9781452158303 (epub)</p>
<p>Library of Congress Cataloging-in-Publication Data<br/>Names: Gibson, Heidi, 1972- author. | Achilleos, Antonis, photographer.<br/>Title: Muffins &amp; biscuits : 50 recipes to start your day with a smile / Heidi<br/>Gibson ; photographs by Antonis Achilleos.<br/>Other titles: Muffins and biscuits<br/>Description: San Francisco : Chronicle Books, [2017] | Includes index.<br/>Identifiers: LCCN 2016021108 | ISBN 9781452158259 (hc : alk. paper)<br/>Subjects: LCSH: Muffins. | Biscuits. | LCGFT: Cookbooks.<br/>Classification: LCC TX770.M83 G53 2017 | DDC 641.81/57—dc23 LC record available at <a href="https://lccn.loc.gov/2016021108" target="_blank">https://lccn.loc.gov/2016021108</a></p>
<p>Designed by <span class="font1">Vanessa Dina</span><br/>Prop styling by <span class="font1">Spork</span><br/>Typesetting by <span class="font1">Frank Brayton</span></p>
<p>Chronicle books and gifts are available at special quantity discounts to corporations, professional associations, literacy programs, and other organizations. For details and discount information, please contact our premiums department at <a href="mailto:corporatesales@chroniclebooks.com">corporatesales@chroniclebooks.com</a> or at 1-800-759-0190.</p>
<p>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, California 94107<br/><a href="http://www.chroniclebooks.com/" target="_blank">www.chroniclebooks.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04copyright.vue?235c5e7e